<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-clipboard-text-multiple
      </v-icon> Webhooks List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <br>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
          <v-spacer />
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="webhooksTable.headers"
        :items=" webhooksList"
        :search="search"
        class="elevation-1"
        item-key="id"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        show-expand
        mobile-breakpoint="100"
      >
        <template #item="{ item, expand, isExpanded }">
          <tr>
            <td>{{ item.type }}</td>
            <td>
              <v-btn
                icon
                small
                @click.stop
                @click="expand(!isExpanded)"
              >
                <v-icon
                  v-if="!isExpanded"
                >
                  mdi-arrow-down-drop-circle
                </v-icon>
                <v-icon v-if="isExpanded">
                  mdi-arrow-up-drop-circle
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template
          #expanded-item="{ headers, item }"
        >
          <td
            :colspan="headers.length"
          >
            <v-row>
              <v-col
                cols="12"
                lg="12"
              >
                <v-card>
                  <v-toolbar
                    color="#37474F"
                    dark
                  >
                    <v-toolbar-title>Webhook Details</v-toolbar-title>
                  </v-toolbar>
                  <v-list>
                    <v-list-item-group>
                      <v-list-item-content class="ml-1">
                        <v-list-item-title class="my-item-title-style">
                          <strong>
                            <font class="my-font-style"> Stripe Id:</font> {{ item.stripe_id }}
                          </strong>
                        </v-list-item-title>
                        <v-list-item-title class="my-item-title-style">
                          <strong>
                            <font class="my-font-style"> Id:</font>  {{ item.id }}
                          </strong>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'WebhooksList',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        search: '',
        loading: false,
        webhooksTable: {
          headers: [
            { text: 'Type', align: 'start', value: 'type' },
            { text: 'More', value: 'data-table-expand' },
          ],
        },
        expanded: [],
        singleExpand: true,
      };
    },
    computed: {
      webhooksList () {
        return this.$store.getters['payments/getWebhooksList'];
      },
    },
    async mounted () {
      await this.getWebhooksList();
    },
    methods: {
      async getWebhooksList () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchWebhooksList');
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.my-font-style {
  color: #546e7a;
  margin-right: 2px;
  padding-left: 16px;
}
.my-item-title-style {
  color: #37474f;
}
</style>
